export default "__VITE_ASSET__nk$c3B9v__"